import React from 'react';
import { connect } from 'react-redux';

import * as organizationConstants from '../../constants/organizations';
import * as organizationMembersSelectors from '../../selectors/organizationMembersSelectors';
import * as userSearchSelectors from '../../selectors/userSearchSelectors';
import * as organizationSelectors from '../../selectors/organizationSelectors';

import AddOrganizationMembers from './AddOrganizationMembers';
import MembersActions from '../../components/members/MembersActions';

const OrganizationMembersActions = props => {
    const { isAdmin, ...rest } = props;

    const adminAction = isAdmin ? <AddOrganizationMembers /> : null;
    return <MembersActions {...rest} adminAction={adminAction} />;
};

const mapStateToProps = state => ({
    searchTerm: organizationMembersSelectors.getOrganizationMembersSearchTerm(
        state,
    ),
    isAdmin: organizationSelectors.getIsCurrentUserAdminForOrganization(state),
    isAddMember: userSearchSelectors.isAddMember(state),
});

const mapDispatchToProps = dispatch => ({
    onSearchChange: searchTerm =>
        dispatch({
            type: organizationConstants.CHANGE_ORGANIZATION_MEMBERS_FILTER,
            payload: searchTerm,
        }),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(OrganizationMembersActions);



// WEBPACK FOOTER //
// ./src/containers/organizationMembers/OrganizationMembersActions.js